import React, { useEffect, useState } from 'react';
import { Button, Card, Form, message, Space, Table } from 'antd';
import axios from 'axios';
import copy from 'copy-to-clipboard';
import BaseView from '../../components/BaseView';
import { Input } from 'antd';
import { Radio } from 'antd';
import { Select } from 'antd';

const name = 'paneland';

const SELECT_OPTIONS = {
  'Dutch - Netherlands': [
    { value: '38237', label: '男' },
    { value: '38238', label: '女' },
  ],
  'English - Australia': [
    { value: '4719', label: '男' },
    { value: '4720', label: '女' },
    { value: '713429', label: '中性' },
  ],
  'English - Canada': [
    { value: '6096', label: '男' },
    { value: '6097', label: '女' },
    { value: '577283', label: '其他' },
  ],
  'English - France': [
    { value: '59575', label: '男' },
    { value: '59576', label: '女' },
  ],
  'English - Germany': [
    { value: '59577', label: '男' },
    { value: '59578', label: '女' },
  ],
  'English - India': [
    { value: '19821', label: '男' },
    { value: '19822', label: '女' },
  ],
  'English - Malaysia': [
    { value: '59020', label: '男' },
    { value: '59021', label: '女' },
  ],
  'English - United Kingdom': [
    { value: '1873', label: '男' },
    { value: '1874', label: '女' },
  ],
  'English - United States': [
    { value: '58', label: '男' },
    { value: '59', label: '女' },
  ],
  'French - Canada': [
    { value: '13295', label: '男' },
    { value: '13296', label: '女' },
  ],
  'French - France': [
    { value: '3293', label: '男' },
    { value: '3294', label: '女' },
    { value: '414974', label: '双性恋' },
    { value: '414975', label: '宁愿不回答' },
  ],
  'German - Germany': [
    { value: '11853', label: '男' },
    { value: '11854', label: '女' },
    { value: '414379', label: '双性恋' },
    { value: '414380', label: '我不想回答' },
  ],
  'German - Switzerland': [
    { value: '31759', label: '男' },
    { value: '31760', label: '女' },
  ],
  'Hindi - India': [
    { value: '99377', label: '男' },
    { value: '99378', label: '女' },
  ],
  'Italian - Italy': [
    { value: '36930', label: '男' },
    { value: '36931', label: '女' },
  ],
  'Spanish - Spain': [
    { value: '47220', label: '男' },
    { value: '47221', label: '女' },
    { value: '416472', label: '双性恋' },
    { value: '416473', label: '我宁愿不回答' },
  ],
  'Spanish - United States': [
    { value: '10213', label: '男' },
    { value: '10214', label: '女' },
  ],
};

function generateUuid() {
  var temp_url = URL.createObjectURL(new Blob());
  var uuid = temp_url.toString();
  URL.revokeObjectURL(temp_url);
  return uuid.substr(uuid.lastIndexOf('/') + 1);
}
function Paneland() {
  const [link, setLink] = useState([]);
  const [uuid, setUuid] = useState('');
  const [formValues, setFormValues] = useState();
  const [form] = Form.useForm();

  const [selectOptions, setSelectOptions] = useState([]);

  useEffect(() => {
    try {
      const json = JSON.parse(localStorage.getItem(`${name}_url_history`));
      const uuid = JSON.parse(localStorage.getItem(`${name}_uuid`));
      setLink(json || []);
      setUuid(uuid || '');
    } catch (e) {
      setLink([]);
    }

    try {
      const json = JSON.parse(localStorage.getItem(`${name}_form`));
      if (!form) return;
      if (json) {
        form.setFieldsValue(json);
        if(json?.country){
          setSelectOptions(SELECT_OPTIONS[json.country]);
        }
        setFormValues(json);
      }
    } catch {}
  }, [form, setFormValues]);

  const handleLink = (e) => {
    axios
      .get(`${name}/getLink`, { params:form.getFieldsValue() })
      .then((res) => {
        const _ = generateUuid();
        setUuid(_);
        localStorage.setItem(`${name}_uuid`, _);
        setLink(res);
        if (res && res.length > 0) {
          localStorage.setItem(`${name}_url_history`, JSON.stringify(res));
        }
      })
      .catch((e) => {
        console.log(e);
        setLink([]);
      });
  };
  return (
    <BaseView name={name}>
      <Card
        title='操作'
        extra={
          <Space>
            <Button
              onClick={() => {
                window.open('/#/collection');
              }}
            >
              统计
            </Button>
            <Button
              onClick={() => {
                axios.get(`${name}/getIp`).then((res) => {
                  message.success(res);
                });
              }}
            >
              检测IP
            </Button>
            <Form
              onFinish={(e) => {
                setLink(null);
                handleLink(e);
              }}
              style={{ height: '32px' }}
            >
              <Space>
                <Form.Item>
                  <Button
                    htmlType='submit'
                    type='primary'
                    loading={link === null}
                  >
                    获取问卷
                  </Button>
                </Form.Item>
              </Space>
            </Form>
          </Space>
        }
      >
        <Form
          form={form}
          onValuesChange={(_, e) => {
            localStorage.setItem(`${name}_form`, JSON.stringify(e));
            setFormValues(e);
          }}
        >
          <Form.Item label='年龄' name='age'>
            <Input type='number' />
          </Form.Item>
          <Form.Item label='国家' name='country'>
            <Select
              options={[
                { label: '荷兰语 - 荷兰', value: 'Dutch - Netherlands' },
                { label: '英语 - 澳大利亚', value: 'English - Australia' },
                { label: '英语 - 加拿大', value: 'English - Canada' },
                { label: '英语 - 法国', value: 'English - France' },
                { label: '英语 - 德国', value: 'English - Germany' },
                { label: '英语 - 印度', value: 'English - India' },
                { label: '英语 - 马来西亚', value: 'English - Malaysia' },
                { label: '英语 - 英国', value: 'English - United Kingdom' },
                { label: '英语 - 美国', value: 'English - United States' },
                { label: '法语 - 加拿大', value: 'French - Canada' },
                { label: '法语 - 法国', value: 'French - France' },
                { label: '德语 - 德国', value: 'German - Germany' },
                { label: '德语 - 瑞士', value: 'German - Switzerland' },
                { label: '印度语 - 印度', value: 'Hindi - India' },
                { label: '意大利语 - 意大利', value: 'Italian - Italy' },
                { label: '西班牙语 - 西班牙', value: 'Spanish - Spain' },
                { label: '西班牙语 - 美国', value: 'Spanish - United States' },
              ]}
              onSelect={(e) => {
                setSelectOptions(SELECT_OPTIONS[e]);
                form.setFieldsValue({ gender: null });
              }}
            />
          </Form.Item>
          <Form.Item label='性别' name='gender'>
            <Radio.Group options={selectOptions} />
          </Form.Item>
          <Form.Item label='邮编' name='zipCode'>
            <Input />
          </Form.Item>
        </Form>
        <Table
          dataSource={link}
          rowKey={(record) => record.project_id}
          columns={[
            {
              title: 'ID',
              dataIndex: 'project_id',
              sorter: {
                compare: (a, b) => parseFloat(a.ID) - parseFloat(b.ID),
                multiple: 0,
              },
            },
            {
              title: '名称',
              dataIndex: 'name',
            },
            {
              title: 'IR',
              dataIndex: 'ir',
              sorter: {
                compare: (a, b) => parseFloat(a.ss) - parseFloat(b.ss),
                multiple: 3,
              },
            },
            {
              title: '要求时间',
              dataIndex: 'loi',
              sorter: {
                compare: (a, b) => parseFloat(a.loi) - parseFloat(b.loi),
                multiple: 2,
              },
            },
            {
              title: '地区/国家',
              dataIndex: 'country',
              sorter: {
                compare: (a, b) => a.country.localeCompare(b.country, 'zh-CN'),
                multiple: 5,
              },
            },
            {
              title: '金额',
              dataIndex: 'cpi',
              sorter: {
                compare: (a, b) => parseFloat(a.cpi) - parseFloat(b.cpi),
                multiple: 1,
              },
            },
            {
              title: '创建时间',
              dataIndex: 'itime',
              sorter: {
                compare: (a, b) =>
                  new Date(b.itime).valueOf() - new Date(a.itime).valueOf(),
                multiple: 6,
              },
            },
            {
              title: '操作',
              render: (value, record) => (
                <Space>
                  <Button
                    type='primary'
                    onClick={() => {
                      window.open(`/api/pe?surveyId=${record.country}`);
                    }}
                  >
                    配额
                  </Button>
                  <Button
                    type='primary'
                    onClick={() => {
                      const cancel = message.loading('正在打开问卷...');
                      axios
                        .post(`${name}/enter`, {
                          age: formValues.age ? Number(formValues.age) : null,
                          sex: formValues.gender
                            ? formValues.gender === '58'
                              ? 58
                              : 59
                            : null,
                          post_code: formValues.zipCode,
                          survey_name: record.project_id,
                          uuid,
                        })
                        .finally((e) => {
                          const url = new URL(record.entry_link);
                          url.searchParams.set('Age', formValues.age || '');
                          url.searchParams.set(
                            'zipCode',
                            formValues.zipCode || '',
                          );
                          url.searchParams.set(
                            'GENDER',
                            formValues.gender || '',
                          );
                          message.destroy();
                          window.open(url.toString());
                        });
                    }}
                  >
                    打开
                  </Button>
                  <Button
                    onClick={() => {
                      const url = new URL(record.entry_link);
                      url.searchParams.set('Age', formValues.age || '');
                      url.searchParams.set('zipCode', formValues.zipCode || '');
                      url.searchParams.set('GENDER', formValues.gender || '');
                      copy(url.toString());
                      message.success('复制成功');
                    }}
                  >
                    复制
                  </Button>
                </Space>
              ),
            },
          ]}
        />
      </Card>
    </BaseView>
  );
}
export default Paneland;
